import { TObjectBase } from "../base";
import { z } from "zod";
import { TTranslationData } from "../common/translation";

export const TRawClientGrantType = z.object({
  clientCredentials: z.boolean().optional(),
});

export type IRawApiClient = z.infer<typeof TRawApiClient>;
export const TRawApiClient = z
  .object({
    name: z.string(),
    contactEmail: z.string().optional(),
    grantType: TRawClientGrantType.optional(),
    defaultScopes: z.array(z.string()).default([]),
    isPublic: z.boolean().optional(),
    ownerCompanies: z.array(z.string()).optional(),
    requiresManualSetup: z.boolean().optional(),
    logoURL: z.string().optional(),
    description: TTranslationData.optional(),
  })
  .extend(TObjectBase.shape);

export type IRawApiClientCompany = z.infer<typeof TRawApiClientCompany>;
export const TRawApiClientCompany = z.object({
  id: z.string(),
  integrationIDs: z.array(z.string()),
});

export type IRawApiClientSecret = z.infer<typeof TRawApiClientSecret>;
export const TRawApiClientSecret = z.object({
  id: z.string(),
  clientSecretHash: z.string().optional(),
});
